import i18n from "@/plugins/i18n";

function parseDeviceAttributeType(type) {
  switch (type) {
    case 1:
      return i18n.t("modules.logs.systemLog.temperature");
    case 2:
      return i18n.t("modules.logs.systemLog.deviceState");
    case 3:
      return i18n.t("modules.logs.systemLog.cellularPort1");
    case 4:
      return i18n.t("modules.logs.systemLog.cellularPort2");
    case 5:
      return i18n.t("modules.logs.systemLog.cellularPort3");
    case 6:
      return i18n.t("modules.logs.systemLog.cellularPort4");
    case 7:
      return i18n.t("modules.logs.systemLog.ethPort1");
    case 8:
      return i18n.t("modules.logs.systemLog.ethPort2");
    case 9:
      return i18n.t("modules.logs.systemLog.wifi");
    case 10:
      return i18n.t("modules.logs.systemLog.vlan");
    case 12:
      return i18n.t("modules.logs.systemLog.simEvent");
    default:
      return "";
  }
}

function parseDate(unFormatedDate) {
  let date = new Date(unFormatedDate);
  let year = date.getFullYear();
  let month = date.getMonth() + 1;
  let day = date.getDate();
  let hours = date.getHours();
  let minutes = date.getMinutes();
  let seconds = date.getMinutes();
  return `${year}-${day}-${month}T${hours}:${minutes}:${seconds}Z`;
}

const csvHeaders = {
  log_time: i18n.t("modules.logs.systemLog.logTime"),
  device_name: i18n.t("modules.logs.systemLog.deviceName"),
  device_serial: i18n.t("modules.logs.systemLog.serialNumber"),
  severity: i18n.t("modules.logs.systemLog.severity"),
  device_attribute_type: i18n.t("modules.logs.systemLog.deviceAttributeType"),
  event_description: i18n.t("modules.logs.systemLog.eventDescription")
};

export default {
  parseDeviceAttributeType,
  parseDate,
  csvHeaders
};
